module.exports = __webpack_public_path__ + "img/intensity_mappting_before.b4efb7c6.png";